import { invoicingApi } from './axiosBase';

export interface SatProductOrServiceOption {
  code: string;
  description: string;
}

/**
 * Search the SAT product/service catalog (c_ClaveProdServ) through the backend wrapper.
 * The backend proxies Facturama and caches results, so the front never holds Facturama
 * credentials and the catalog stays up to date with no local seeding.
 *
 * The backend's BaseJSONRenderer wraps non-paginated responses in `{ data: ..., datetime }`,
 * so the actual payload lives one level deeper than the view's literal Response body.
 */
export async function searchSatProductsOrServices(query: string): Promise<SatProductOrServiceOption[]> {
  const response = await invoicingApi.get('/v1/invoicing/catalogs/sat/products-or-services/', {
    params: { q: query },
  });
  return response.data?.data?.results ?? [];
}
